import React, { useState } from 'react';
import { Box, Collapse, Flex, Icon, Text, VStack, HStack, } from '@chakra-ui/react';
import { ChevronDownIcon, ChevronRightIcon } from '@chakra-ui/icons';
import COLORS from '../../../../../constants/colors';
import moment from 'moment';
import EventDocumentItem from '../event-document-item/index.web';
const EventGroup = ({ title, documents, onDocumentPress, }) => {
    const [isOpen, setIsOpen] = useState(false);
    const displayTitle = title;
    const eventDate = documents?.[0]?.issuedOn || documents?.[0]?.createdOn;
    const formattedDate = eventDate ? moment(eventDate).format('L') : null;
    const documentCount = documents?.length || 0;
    const eventTitleStyle = { fontWeight: 'medium', fontSize: '14px' };
    const dateStyle = { fontSize: '12px', color: 'gray.600' };
    const getDocumentCountText = (count) => {
        return count === 1 ? `(${count} document)` : `(${count} documents)`;
    };
    return (<Box width="100%">
      <Flex as="button" width="100%" align="center" onClick={() => setIsOpen(!isOpen)} py={2} px={2} _hover={{ bg: 'gray.50' }} borderRadius="md">
        <Icon as={isOpen ? ChevronDownIcon : ChevronRightIcon} boxSize={4} mr={2} color={COLORS.Text.T400.value}/>
        <HStack justify="space-between" width="100%">
          <Text {...eventTitleStyle} textAlign="left">{`${displayTitle} ${getDocumentCountText(documentCount)}`}</Text>
          {formattedDate && <Text {...dateStyle}>{formattedDate}</Text>}
        </HStack>
      </Flex>
      <Collapse in={isOpen} animateOpacity>
        <VStack align="stretch" pl={6} pt={2} spacing={1}>
          {documents.map((doc, index) => (<EventDocumentItem key={doc.id || index} document={doc} onDocumentPress={onDocumentPress}/>))}
        </VStack>
      </Collapse>
    </Box>);
};
export default EventGroup;
